import template from "./pInterrupts.html";

export function pInterruptsDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pInterruptsController,
    controllerAs: 'pInterrupts',
    bindToController: true
  };

  return directive;
}

class pInterruptsController {
  constructor(Auth, Admin, $scope, $interval, Notes) {
    'ngInject';

    this.Auth = Auth;
    this.Admin = Admin;
    this.$scope = $scope;
    this.$interval = $interval;
    this.Notes = Notes;

    this.init();

    this.fields = {
      name: "name"
    };

    this.globalActions = [
      {
        name: "add",
        functionName: "startAddinNewInterrupt",
        fa: "fa-plus"
      }
    ];

    this.rowActions = [
      {
        name: "edit",
        functionName: "startEditingInterrupt",
        fa: "fa-pencil-alt"
      },
      {
        name: "delete",
        functionName: "startDeletingInterrupt",
        fa: "fa-trash"
      }
    ];

    /*
    * b-dialog-card data
    */

    this.interruptData = {
      name: {
        type: "text"
      }
    };
  }

  init() {
    this.state = 'loading';
    this.Auth.authorizeAdmin().then(
      (user) => {
        this.user = user;
        if (!this.user.isAdmin) {
          this.Auth.handleUnauthorized();
        }

        this.Admin.getInterrupts().then(
          (success) => {
            this.interrupts = success.data.sort((a, b) => {
              if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }

              return 0;
            });
            this.state = 'loaded';
          },
          (error) => {
            this.state = 'loaded';
            this.Notes.postNote({type: "error", error: error});
          }
        );

        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  startAddinNewInterrupt() {
    this.newInterruptProcess = true;
    this.newInterruptValues = null;
  }

  addInterrupt(interrupt) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.addInterrupt(interrupt).then(
      () => {
        this.newInterruptProcess = false;
        this.newInterrupt = null;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startEditingInterrupt(interrupt) {
    this.editInterruptProcess = true;
    this.editInterruptValues = interrupt;
  }

  updateInterrupt(interrupt) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.updateInterrupt(interrupt.id, interrupt).then(
      () => {
        this.editInterruptProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startDeletingInterrupt(interrupt) {
    this.deleteInterruptProcess = true;
    this.deleteInterruptValues = interrupt;
  }

  deleteInterrupt(interrupt) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.deleteInterrupt(interrupt.id).then(
      () => {
        this.deleteInterruptProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }
}
